import React, {Component} from "react"
import _ from "lodash"
import {Form, Header} from "semantic-ui-react"
import api from "../../../api"
import {withTranslation} from 'react-i18next'

import {Fields} from "./Field"
import FormAttachments from "./FormAttachments"
import FormComment from "./FormComment"

import ChoiceStep from "./ChoiceStep"
import SignatureStep from "./SignatureStep"

class Step extends Component {

  constructor({step}) {
    super()
    this.state      = {
      step
    }
    this.updateStep = _.debounce(api.putStep, 300, {trailing: true})
  }

  componentWillReceiveProps({step}) {
    if (this.state.step !== step) {
      this.setState({step})
    }
  }

  componentDidMount() {
    api.track({
      eventCategory: "Schritt bearbeiten",
      eventAction:   'open',
      eventLabel:    this.state.step.TypeCode
    })
  }

  handleChange = (step) => {
    this.updateStep(this.state.step)
    this.forceUpdate()
  }

  render() {
    let {step}             = this.state
    let CustomContent      = stepComponentsByType.get(step.Type)
    let showComments       = stepShowComment.get(step.Type)
    let showAttachments    = stepShowAttachments.get(step.Type)
    let stepTrackingNumber = api.stepnumbers.get(step.Id)
    const {t} = this.props;

    return (
      <div>
        <Header as='h3'><span className="black-60 f5">{t("general.step.single")} {stepTrackingNumber}</span>
          <br/>{step.Name}</Header>
        {(step.Description) ?
          <div className="pb3 step-description black" dangerouslySetInnerHTML={{__html: step.Description}}/> : null }
        {(CustomContent) ? <CustomContent step={step} onChange={this.handleChange}/> : null}
        <Form>
          {showComments ? <FormComment key={step.Id} step={step} onChange={this.handleChange}/> : null}
        </Form>
        {showAttachments ? <FormAttachments key={step.Id} step={step} onChange={this.handleChange}/> : null }
      </div>
    )
  }
}

export default withTranslation()(Step)

const PictureStep    = (step) => ( <h2>PictureStep</h2>)
const EnterValueStep = ({step, onChange}) => (
  <Form>
    <Fields key={step.Id} step={step} onChange={() => {
      onChange(step)
    }}/>
  </Form>
)
const MaterialStep   = (step) => ( <h2>MaterialStep</h2>)
const EnterTextStep  = (step) => ( <h2>EnterTextStep</h2>)
const GroupStep      = (step) => ( <h2>GroupStep</h2>)
const CustomStep     = (step) => ( <h2>CustomStep</h2>)

const STEPTYPE = {
  Choice:       0,
  Picture:      1,
  EnterValue:   2,
  SignDocument: 3,
  Material:     4,
  EnterText:    5,
  Group:        6,
  CustomStep:   7
}

const stepComponentsByType = new Map()
stepComponentsByType.set(STEPTYPE.Choice, ChoiceStep)
stepComponentsByType.set(STEPTYPE.Picture, PictureStep)
stepComponentsByType.set(STEPTYPE.EnterValue, EnterValueStep)
stepComponentsByType.set(STEPTYPE.Material, MaterialStep)
stepComponentsByType.set(STEPTYPE.EnterText, EnterTextStep)
stepComponentsByType.set(STEPTYPE.CustomStep, CustomStep)
stepComponentsByType.set(STEPTYPE.Group, GroupStep)
stepComponentsByType.set(STEPTYPE.SignDocument, SignatureStep)

const stepShowComment = new Map()
stepShowComment.set(STEPTYPE.Choice, true)
stepShowComment.set(STEPTYPE.Picture, true)
stepShowComment.set(STEPTYPE.EnterValue, true)
stepShowComment.set(STEPTYPE.Material, true)
stepShowComment.set(STEPTYPE.EnterText, true)
stepShowComment.set(STEPTYPE.CustomStep, true)
stepShowComment.set(STEPTYPE.Group, false)
stepShowComment.set(STEPTYPE.SignDocument, false)

const stepShowAttachments = new Map()
stepShowAttachments.set(STEPTYPE.Choice, true)
stepShowAttachments.set(STEPTYPE.Picture, true)
stepShowAttachments.set(STEPTYPE.EnterValue, true)
stepShowAttachments.set(STEPTYPE.Material, true)
stepShowAttachments.set(STEPTYPE.EnterText, true)
stepShowAttachments.set(STEPTYPE.CustomStep, true)
stepShowAttachments.set(STEPTYPE.Group, false)
stepShowAttachments.set(STEPTYPE.SignDocument, false)




// WEBPACK FOOTER //
// ./src/pages/components/Step/Step.js